import { HttpMethod, HttpOption } from '@/utils/http-client'
import { BlacklistConfigUpdateRequest } from '@/api/model/blacklist'

export class BlacklistAPIConstant {
    query = (): HttpOption => ({
        url: '/fundcloud/blacklist/config/query',
        method: HttpMethod.GET
    })

    update = (data: BlacklistConfigUpdateRequest): HttpOption => ({
        url: '/fundcloud/blacklist/config/update',
        method: HttpMethod.POST,
        data
    })
}
